import { render, staticRenderFns } from "./Breakfast.vue?vue&type=template&id=2d3dd62a&scoped=true&"
import script from "./Breakfast.vue?vue&type=script&lang=js&"
export * from "./Breakfast.vue?vue&type=script&lang=js&"
import style0 from "./Breakfast.vue?vue&type=style&index=0&id=2d3dd62a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3dd62a",
  null
  
)

export default component.exports